export default "__VITE_ASSET__D22PH_Ws__"